document.addEventListener('DOMContentLoaded', function () {
  var instances = new WeakMap();

  function initCarousel(wrapper) {
    if (typeof Flickity === 'undefined') return;
    if (window.innerWidth > 768) return;
    if (instances.has(wrapper)) return;
    instances.set(
      wrapper,
      new Flickity(wrapper, {
        cellAlign: 'left',
        contain: true,
        wrapAround: wrapper.dataset.sfCarouselWrap !== 'false',
        prevNextButtons: true,
        pageDots: true,
        draggable: true,
        adaptiveHeight: false,
        imagesLoaded: true
      })
    );
  }

  function destroyCarousel(wrapper) {
    var instance = instances.get(wrapper);
    if (!instance) return;
    instance.destroy();
    instances.delete(wrapper);
  }

  function sync() {
    document.querySelectorAll('[data-sf-carousel]').forEach(function (wrapper) {
      if (window.innerWidth <= 768) {
        initCarousel(wrapper);
      } else {
        destroyCarousel(wrapper);
      }
    });
  }

  sync();
  window.addEventListener('resize', sync);
});
